import { Box, Typography } from "@mui/material";
import palette from "../../../theme/palette";
import "./adminMessage.css";

interface iProps {
	adminMessage: string;
}

const AdminMessageComponent = ({ adminMessage }: iProps) => {
	return adminMessage ? (
		<Box className="admin-message-box">
			<Typography sx={{ color: palette.secondary.main, fontSize: 16, fontWeight: 500 }}>
				Message from YouCater admin
			</Typography>
			<Typography className="admin-message-box__text" sx={{ color: palette.grey[800], fontSize: 14, fontWeight: 400 }}>
				{adminMessage ?? ""}
			</Typography>
		</Box>
	) : null;
};

export default AdminMessageComponent;
